// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"15cb823e","213":"bb5295b6","453":"513f6c27","455":"e1baa380","768":"e06f19d0"}[chunkId] + ".chunk.js";
};